import { useMemo } from "react";
import { useIntl } from "react-intl";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";
import FAQ from "../../components/FAQ";
import FAQStructuredData from "../../components/FAQStructuredData";
import AccordionVariables from "../../variables/variables.json";
import { getFaqItemsFromSection } from "../../lib/faq";

import DrukIN11 from "../../content/przyjaznedeklaracje/najczesciej-zadawane-pytania-faq/section-1_pl.mdx";
import Image from "next/image";

const FAQ_SECTIONS = [
	{
		section: "pytaniain1",
		title: "sections.pytaniain1.title",
		id: "pytania-dotyczace-informacji-in-1",
		lighterdark: false,
	},
	{
		section: "pytaniadn1",
		title: "sections.pytaniadn1.title",
		id: "pytania-dotyczace-deklaracji-dn-1",
		lighterdark: true,
	},
	{
		section: "pytaniain1dn1",
		title: "sections.pytaniain1dn1.title",
		id: "pytania-dotyczace-nieruchomosci-in-1-dn-1",
		lighterdark: false,
	},
	{
		section: "pytaniadt1",
		title: "sections.pytaniadt1.title",
		id: "pytania-dotyczace-deklaracji-dt-1",
		lighterdark: true,
	},
	{
		section: "pytaniaogolne",
		title: "sections.pytaniaogolne.title",
		id: "pytania-ogolne",
		lighterdark: false,
	},
	{
		section: "pytanianiezbedneinformacje",
		title: "sections.pytanianiezbedneinformacje.title",
		id: "pytania-dotyczace-danych-niezbednych-w-informacji-deklaracji",
		lighterdark: true,
	},
];

export default function DrukIN1(props) {
	const intl = useIntl();

	const Miasto = "PRZYJAZNEDEKLARACJE";
	const Podatek = "najczesciejzadawanepytaniafaq";

	const faqItems = useMemo(() => {
		const faqRoot = AccordionVariables.miasta?.[Miasto]?.FAQ;

		return FAQ_SECTIONS.flatMap(({ section }) =>
			getFaqItemsFromSection({
				faqRoot,
				section,
				translate: (id) => intl.formatMessage({ id }),
			}),
		);
	}, [intl]);

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<FAQStructuredData
				items={faqItems}
				pageUrl="/najczesciej-zadawane-pytania-faq/"
			/>

			<Section mdx lighterdark noPanel>
				<DrukIN11 />
			</Section>

			{FAQ_SECTIONS.map(({ section, title, id, lighterdark }) => (
				<Section key={section} title={title} id={id} lighterdark={lighterdark} titleLeft>
					<FAQ miasto={Miasto} section={section} secondary schema={false} />
				</Section>
			))}

			<Section>
				<div className="pd-contact">
					<div className="pd-contact__top">
						<h2 className="pd-contact__title">Nie możesz znaleźć odpowiedzi na pytanie?</h2>
						<p>
							Skontaktuj się, aby uzyskać pomoc. Nasi konsultanci są do dyspozycji od poniedziałku
							do piątku w godzinach 7:00-15:00.
						</p>

						<div className="pd-contact__info main">
							<Image
								unoptimized
								src="https://przyjazne-deklaracje.pl/resources/images/icons/general/contact/icon-email.svg"
								alt=""
								width={37}
								height={26}
								style={{
									maxWidth: "100%",
									height: "auto",
								}}
							/>
							<a href="mailto:pomoc@przyjazne-deklaracje.pl">pomoc@przyjazne-deklaracje.pl</a>
						</div>

						<div className="pd-contact__info main">
							<Image
								unoptimized
								src="https://przyjazne-deklaracje.pl/resources/images/icons/general/contact/icon-phone-call.svg"
								alt=""
								width={26}
								height={26}
								style={{
									maxWidth: "100%",
									height: "auto",
								}}
							/>
							<a href="tel:+48530607002">+48 530 607 002</a>
						</div>

						<hr />

						<p>
							<span className="text-bold">Uwaga!</span> W innych sprawach takich jak wysokość stawek
							podatkowych, numery kont itp. kontaktuj się bezpośrednio z Twoim Urzędem.
						</p>
					</div>
				</div>
			</Section>
		</SectionLayout>
	);
}
